import { render, staticRenderFns } from "./GruposForm.vue?vue&type=template&id=0937b69d&scoped=true&"
import script from "./GruposForm.vue?vue&type=script&lang=js&"
export * from "./GruposForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0937b69d",
  null
  
)

export default component.exports